var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('v-btn',{staticClass:"scroll-to-top",attrs:{"fab":"","dark":""},on:{"click":_vm.scrollToTop}},[_c('v-icon',[_vm._v("mdi-arrow-up")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }